import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './MainNav.scss'
import MainNavSection from './MainNavSection'
import { matchPath } from 'react-router'

import { ShowUserProfileButton } from '../../containers/Buttons'

const match = (path, location, exact) => {
	return matchPath(location.pathname, { path, exact })
}

// just fooling around, totally worth refactoring
// fix for mobile
const Top = location => {
	if (match('/', location, true)) return 15
	if (match('/apps', location, false)) return 75
	if (match('/explore', location, false)) return 135
	else return -100
}

class MainNav extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			notifications: {
				home: 0,
				apps: 0,
				explore: 0
			}
		}
	}

	render() {
		return (
			<div styleName="mainNav">
				<div
					styleName="slider"
					style={{ top: Top(this.props.location) }}
				/>

				<MainNavSection
					path="/"
					icon="home"
					label="Home"
					notifications={this.state.notifications.home}
				/>

				<MainNavSection
					path="/apps"
					icon="view_list"
					label="Apps"
					notifications={this.state.notifications.apps}
				/>

				<MainNavSection
					path="/explore"
					icon="explore"
					label="Explore"
					notifications={this.state.notifications.explore}
				/>

				<MainNavSection
					icon="help"
					label="Support"
					align="bottom"
					onClick={() => {
						const LC_API = window.LC_API || {}
						if (LC_API.chat_window_hidden()) {
							LC_API.open_chat_window()
						} else {
							LC_API.hide_chat_window()
						}
					}}
				/>
				<ShowUserProfileButton />
			</div>
		)
	}
}

export default CSSModules(MainNav, styles)



// WEBPACK FOOTER //
// ./src/components/Navigation/MainNav.js